<template>
  <div class="page-certificate-detail"
       :class="{ 'audio': this.type === 'audio' }"
       v-if="src !== ''"
  >
    <div class="img-block">
      <ym-img class="img"
              :src="src"
              alt="我的证书"
      />
    </div>
    <div class="hint">长按保存图片</div>
  </div>
</template>

<script>
  import { getCertificateDetail } from '@/services/certificate';

  export default {
    name: 'PageCertificateDetail',
    metaInfo: {
      title: '我的证书',
    },
    data() {
      return {
        type: '',
        src: '',
      };
    },
    methods: {
      async fetchData() {
        const data = await getCertificateDetail(this.$route.params.id);
        this.src = data.src;
        this.type = data.type;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-certificate-detail {
    height: 100%;
    padding: @size-large @size-base 0 @size-base;
    box-sizing: border-box;
    background: @color-white;
    &.audio {
      padding-top: @size-large + @size-base;
    }
  }

  .img-block {
    width: 690px;
    margin: 0 auto;
    box-shadow: 0 5px 5px 0 #e7e7e7;
    .img {
      width: 100%;
      display: block;
    }
  }

  .hint {
    margin-top: @size-small;
    font-size: @font-size-medium;
    text-align: center;
    color: @color-text-lighter;
  }

</style>
